import React from "react";
import classNames from "classnames";
// import { Button } from "./Buttons";
import { withStyles } from "@material-ui/core/styles";
// import { Link } from "react-router-dom";
import { ProgressiveImage } from "./Image";
import { isMobile } from "../userAgentDetect";

const styles = theme => ({
  container: {
    width: "100%",
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column"
    }
  },
  reverse: {
    flexDirection: "row-reverse",
    backgroundColor: "#FDFDF9",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column"
    }
  },
  textContainer: {
    flex: 1,
    padding: [[0, 56]],
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      padding: [[40,32, 48,32]],
    }
  },
  title: {
    marginBottom: "0.6em",
    textTransform:"uppercase"
  },
  desc: {
    lineHeight: 1.7
  },
  image: {
    width: "50%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    }
  }
});

let HomeSection = ({
  classes,
  id,
  title,
  desc,
  imageLarge,
  imageSmall,
  reverse
}) => (
  <div
    className={classNames(classes.container, {
      [classes.reverse]: reverse
    })}
  >
    <ProgressiveImage
      className={classes.image}
      imgSmall={imageSmall}
      imgLarge={imageLarge}
      alt={title}
      backgroundColor="rgba(0,0,0,0)"
      paddingBottom={isMobile?"80%":`90%`}
    />
    <div className={classes.textContainer}>
      <h4 className={classes.title}>{title}</h4>
      <p className={classes.desc}>{desc}</p>
    </div>
  </div>
);

export default withStyles(styles)(HomeSection);



// WEBPACK FOOTER //
// ./src/components/HomeSection.js